import { ColorOptions } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { WrapperText } from '../../components/WrapperText'

const textinputStyle = {
  type: 'body14',
  borderColor: '#d1d3e2' as ColorOptions,
  labelPaddingBottom: 8,
  borderRadius: 4,
  labelFontFamily: 'jiotype-bold',
  fontFamily: 'jiotype-medium',
  labelColor: '#6e707e' as ColorOptions,
  labelFontSize: 12,
  fontSize: 14,
  selectionColor: 'BLUE',
  paddingHorizontal: 8,
  color: '#6e707e' as ColorOptions,
  paddingVertical: 8,
  focusBorderColor: '#d1d3e2' as ColorOptions,
  borderWidth: 2,
  onFocusBorderWidth: 2,
}
export const editForm: any = (updateMapping: (values: any) => void, message: string) => [
  {
    key: 'cardInfo',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'entityCode',
            ComponentName: TextInputNew,
            label: 'Entity Bank Code',
            placeholder: 'Entity Bank Code',
            // validationSchema: required,
            ...textinputStyle,
          },
          {
            fieldName: 'rpslCode',
            ComponentName: TextInputNew,
            label: 'RPSL Bank Code',
            placeholder: 'RPSL Bank Code',
            // validationSchema: required,
            ...textinputStyle,
          },
          {
            fieldName: 'bankName',
            ComponentName: TextInputNew,
            label: 'Bank Name',
            placeholder: 'Bank Name',
            // validationSchema: required,
            ...textinputStyle,
          },
        ],
      },
      {
        fieldName: 'message',
        ComponentName: WrapperText,
        title: message,
        color: 'ERROR',
        hide: message === '',
      },
    ],
    horizontalFlex: 1,
    onSubmit: async (values: any) => {
      updateMapping(values)
      return 'end'
    },
    actionTitle: 'Update Mapping',
  },
]
